﻿'use strict';

angular.module('ntmApp').factory('SimpleFilter', function () {

    function SimpleFilter(getLabelAction, blankSimpleDisplayLabel) {

        this.filterItem = null;
        this.displayLabelAction = getLabelAction;

        this.isDefined = function () {
            return this.filterItem !== null && this.filterItem !== undefined && this.filterItem !== "";
        };

        this.isPartlyDefined = function () {
            return this.isDefined();
        };

        this.clear = function () {
            this.filterItem = null;
        };

        this.getLabel = function () {

            if (this.displayLabelAction) {
                return this.displayLabelAction(getItemValueConsideringBlankOPtion(this.filterItem));
            }

            return getItemValueConsideringBlankOPtion(this.filterItem);
        };

        function getItemValueConsideringBlankOPtion(item) {

            if (item.id) {
                return item.value;
            }

            return blankSimpleDisplayLabel ? blankSimpleDisplayLabel : item.value;

        }
    }

    return (SimpleFilter);
});